import type {
	AirHostPricePlan,
	SiteControllerSettingAirHostPricePLan_SettingPage_QueryQuery,
} from "@/lib/gql/__generated__/graphql";

import { FeatureIslandContainer, FeatureIslandMainWithBackGround } from "@/components/features/_layouts";
import type { SiteControllerSettingAirHostFormModel } from "@/components/features/settings/site-controller/model/air-host/type";
import type { SiteControllerSettingAirHostFormModelMethodsType } from "@/components/features/settings/site-controller/model/air-host/use-case/use-create-model/methods";

import { SettingsSiteControllerAirHostRoomMappingSection } from "./section";

import type { SiteControllerSettingBaseFormModel } from "../../../../../model/base/type";
import type { SiteControllerSettingBaseFormModelMethodsType } from "../../../../../model/base/use-case/use-create-model/methods";

type Props = {
	baseViewModel: SiteControllerSettingBaseFormModel["ViewModel"]; //
	siteControllerSettingBaseFormModelMethodsType: SiteControllerSettingBaseFormModelMethodsType;

	airHostViewModel: SiteControllerSettingAirHostFormModel["ViewModel"];
	siteControllerSettingAirHostFormModelMethods: SiteControllerSettingAirHostFormModelMethodsType;

	queryData: SiteControllerSettingBaseFormModel["QueryData"];
	pricePlanData: AirHostPricePlan[];
	onRefetchAirHostPricePlan: (input: {
		hotelID: string;
	}) => Promise<SiteControllerSettingAirHostPricePLan_SettingPage_QueryQuery | undefined>;
	onSetPricePlanData: (pricePlanData: AirHostPricePlan[]) => void;
};

export const SettingsSiteControllerAirHostRoomMappingIsland = ({
	airHostViewModel,
	siteControllerSettingAirHostFormModelMethods,

	queryData,
	pricePlanData,
	onRefetchAirHostPricePlan,
	onSetPricePlanData,
}: Props) => {
	return (
		<FeatureIslandContainer>
			<FeatureIslandMainWithBackGround islandTitle="紐付け設定">
				<SettingsSiteControllerAirHostRoomMappingSection
					airHostViewModel={airHostViewModel}
					siteControllerSettingAirHostFormModelMethods={siteControllerSettingAirHostFormModelMethods}
					queryData={queryData}
					pricePlanData={pricePlanData}
					onRefetchAirHostPricePlan={onRefetchAirHostPricePlan}
					onSetPricePlanData={onSetPricePlanData}
				/>
			</FeatureIslandMainWithBackGround>
		</FeatureIslandContainer>
	);
};

SettingsSiteControllerAirHostRoomMappingIsland.displayName = "SettingsSiteControllerAirHostRoomMappingIsland";
